// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarImage_wrapper__3G2tr","img":"AvatarImage_img__3DVwg"};